export const About = (props) => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
  };

  const allItems = props.data
    ? [...(props.data.Why || []), ...(props.data.Why2 || [])]
    : [];

  return (
    <section id='about' style={{ padding: '100px 0', background: '#f8faff' }}>
      <div className='container'>
        <div className='about-layout'>

          {/* ── LEFT: Image with overlapping card ── */}
          <div style={{ position: 'relative' }}>

            {/* Main image */}
            <div style={{
              borderRadius: '20px',
              overflow: 'hidden',
              aspectRatio: '4/5',
              boxShadow: '0 24px 60px rgba(0,0,0,0.14)',
            }}>
              <img
                src='https://res.cloudinary.com/dpk0bkket/image/upload/v1770771602/AC%20TECH/WhatsApp_Image_2026-02-11_at_00.25.47_tntotn.jpg'
                alt='ACTECH team at work'
                style={{
                  width: '100%', height: '100%',
                  objectFit: 'cover', objectPosition: 'center top',
                  display: 'block',
                }}
              />
            </div>

            {/* Overlapping stats card */}
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              right: '-30px',
              background: '#fff',
              borderRadius: '16px',
              padding: '24px 28px',
              boxShadow: '0 16px 48px rgba(0,0,0,0.12)',
              minWidth: '200px',
            }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {[
                  { value: '20+', label: 'Years in Operation' },
                  { value: `${props.contact?.reviewCount || '105'}+`, label: 'Client Reviews' },
                  { value: `${props.contact?.rating || '4.5'}★`, label: 'Google Rating' },
                ].map((s, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <div style={{
                      width: '4px', height: '36px',
                      background: 'linear-gradient(to bottom, #5ca9fb, #6372ff)',
                      borderRadius: '2px', flexShrink: 0,
                    }}></div>
                    <div>
                      <div style={{
                        fontFamily: 'Raleway, sans-serif',
                        fontSize: '20px', fontWeight: '800',
                        color: '#0f0f1a', lineHeight: 1,
                      }}>{s.value}</div>
                      <div style={{ fontSize: '12px', color: '#999', fontWeight: '500', marginTop: '2px' }}>{s.label}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Founded badge */}
            <div style={{
              position: 'absolute',
              top: '20px',
              left: '20px',
              background: 'linear-gradient(135deg, #5ca9fb, #6372ff)',
              borderRadius: '12px',
              padding: '12px 18px',
              color: '#fff',
              textAlign: 'center',
              boxShadow: '0 8px 24px rgba(92,169,251,0.4)',
            }}>
              <div style={{ fontFamily: 'Raleway, sans-serif', fontSize: '22px', fontWeight: '800', lineHeight: 1 }}>2006</div>
              <div style={{ fontSize: '11px', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase', opacity: 0.85 }}>Est.</div>
            </div>

          </div>

          {/* ── RIGHT: Text content ── */}
          <div style={{ paddingTop: '10px' }}>

            {/* Label */}
            <p style={{
              color: '#5ca9fb', fontWeight: '700',
              fontSize: '12px', letterSpacing: '3px',
              textTransform: 'uppercase', margin: '0 0 16px',
            }}>
              — About Us
            </p>

            {/* Headline */}
            <h2 style={{
              fontFamily: 'Raleway, sans-serif',
              fontSize: 'clamp(28px, 3.2vw, 44px)',
              fontWeight: '800', color: '#0f0f1a',
              lineHeight: '1.15', margin: '0 0 20px',
            }}>
              Your Commercial<br />
              <span style={{ color: '#5ca9fb' }}>HVAC Partner</span>
            </h2>

            {/* Paragraph */}
            <p style={{
              color: '#777', fontSize: '16px',
              lineHeight: '1.85', margin: '0 0 32px',
            }}>
              {props.data ? props.data.paragraph : 'Loading...'}
            </p>

            {/* Checklist */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '12px',
              marginBottom: '40px',
            }}>
              {allItems.map((item, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'flex-start', gap: '10px',
                  padding: '12px 14px',
                  background: '#fff',
                  borderRadius: '10px',
                  border: '1px solid #eef0ff',
                }}>
                  <div style={{
                    width: '22px', height: '22px', borderRadius: '50%',
                    background: 'linear-gradient(135deg, #5ca9fb, #6372ff)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0, marginTop: '1px',
                  }}>
                    <i className='fa fa-check' style={{
                      color: '#fff', fontSize: '10px',
                      display: 'block',
                      lineHeight: 1,
                    }}></i>
                  </div>
                  <span style={{ color: '#444', fontSize: '14px', fontWeight: '600', lineHeight: '1.4' }}>
                    {item}
                  </span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <a
              href='#services'
              onClick={(e) => { e.preventDefault(); scrollTo('#services'); }}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '10px',
                background: 'linear-gradient(to right, #5ca9fb, #6372ff)',
                color: '#fff', padding: '14px 30px', borderRadius: '50px',
                textDecoration: 'none', fontWeight: '700', fontSize: '14px',
                textTransform: 'uppercase', letterSpacing: '0.5px',
                boxShadow: '0 8px 24px rgba(92,169,251,0.35)',
              }}
            >
              Explore Our Services
              <i className='fa fa-arrow-right' style={{ fontSize: '13px' }}></i>
            </a>

          </div>
        </div>
      </div>

      <style>{`
        .about-layout {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 100px;
          align-items: center;
        }
        @media (max-width: 900px) {
          .about-layout {
            grid-template-columns: 1fr !important;
            gap: 80px !important;
          }
          .about-layout > div:first-child {
            margin-bottom: 40px;
          }
        }
        @media (max-width: 500px) {
          .about-layout > div:first-child > div:nth-child(2) {
            right: 0 !important;
            bottom: -20px !important;
          }
        }
      `}</style>
    </section>
  );
};
